export enum ClientSubscriptionFlag {
  WebinarTemplatesEnabled = 'isWebinarTemplatesEnabled',
  PaidWebinarsEnabled = 'isPaidWebinarsEnabled',
  AutomationTemplatingEnabled = 'isAutomationTemplatingEnabled',
}
